import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CONSTANTS } from 'src/app/providers/constants';

/** Tells the API which store the dashboard is currently embedded in. See `ShopifyGuard`. */
export const SHOP_HEADER = 'X-Goodchart-Shop';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const constants = inject(CONSTANTS);
  const token = localStorage.getItem(constants.AUTH_TOKEN_KEY as string);

  if (!token) return next(req);

  let headers = req.headers.set('Authorization', `Bearer ${token}`);

  // The stored token is bound to the shop it was minted for, but localStorage is shared by every
  // store that embeds the app, so it can outlive a store switch. Declaring the current shop lets
  // the API reject a token that belongs to another one, which comes back as the usual 401 +
  // retry header and makes `shopifyInterceptor` mint a correct token. Only sent alongside a
  // token: an unauthenticated GET would otherwise stop being a CORS-simple request and start
  // paying for a preflight.
  const shop = window.shopify?.config?.shop;

  if (shop) headers = headers.set(SHOP_HEADER, shop);

  return next(req.clone({ headers }));
};
